import * as React from 'react';
import { Switch, } from 'react-router-dom';
import IndexHeader from '@/display/components/IndexHeader';
import IndexFooter from '@/display/components/IndexFooter';
import routes from './router';
// import { Modal, Button } from 'antd';

// import { connect } from 'react-redux';
// //需要渲染什么数据
// function mapStateToProps(state) {
//   return {
//     tiger: state
//   }
// }
// //需要触发什么行为
// function mapDispatchToProps(dispatch) {
//   return {
//     PayIncrease: () => dispatch({ type: '涨工资' }),
//     PayDecrease: () => dispatch({ type: '扣工资' })
//   }
// }
class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalVisible:true
    };
  }
  handleOk = () => {
    this.setState({
      isModalVisible: false
    })
  };

  // handleCancel = () => {
  //   this.setState({
  //     isModalVisible: false
  //   })
  // };
  render() {
    // console.log(this.props)
    return (
      <div className={"index" + (this.props && this.props.location && this.props.location.pathname === '/' ? " index-index" : "")}>
        <IndexHeader />
        <div
          className="index-main"
          // style={(this.props && this.props.location && this.props.location.pathname === '/service/result' ? { height: '1rem' } : {})}
        >
          <Switch>
            {routes}
          </Switch>
        </div>
        <IndexFooter />
        {/* <Modal title="通知" visible={this.state.isModalVisible} onOk={this.handleOk} closable={false}
          footer={[<Button type="primary" onClick={this.handleOk}>我知道了</Button>]}>
          <p>因配合国家限电政策，暂时无法提供服务</p>
        </Modal> */}
      </div >
    );
  }
}

export default Home;
